<template>
	<q-dialog
		ref="dialogRef"
		@hide="onDialogHide"
	>
		<q-card class="q-dialog-plugin">
			<iframe
				:src="CRUrl"
				name="myFrame"
				width="100%"
				height="99%"
			/>
		</q-card>
	</q-dialog>
</template>

<script setup>
import { useSpeakStore } from '@/stores/speak'
import { useDialogPluginComponent } from 'quasar'
import { computed } from 'vue'

const { dialogRef, onDialogHide } = useDialogPluginComponent()
const speakStore = useSpeakStore()

const languageMap = {
	en: 'english',
	it: 'italian',
	fr: 'french'
}
const CRUrl = computed(() => `https://context.reverso.net/translation/${languageMap[speakStore.currentLanguage] || 'english'}-russian`)

defineEmits([...useDialogPluginComponent.emits])
</script>

<style lang="scss" scoped>
.q-dialog-plugin {
	height: 75%;
	width: 100%;
}
</style>
